import { Component } from "@angular/core";
import { RouterModule } from "@angular/router";
import { MatIconRegistry } from "@angular/material/icon";
import { DomSanitizer } from "@angular/platform-browser";
import { NgxSpinnerComponent } from "ngx-spinner";

@Component({
    selector: "app-root",
    standalone: true,
    imports: [RouterModule, NgxSpinnerComponent],
    templateUrl: "./app.component.html",
    styleUrl: "./app.component.scss",
})
export class AppComponent {
    constructor(
        private matIconRegistry: MatIconRegistry,
        private sanitizer: DomSanitizer,
    ) {
        this.matIconRegistry.addSvgIcon(
            "dg_calendar",
            this.sanitizer.bypassSecurityTrustResourceUrl("/assets/icons/calendar-icon.svg"),
        );
    }
}
